import { Col, Pagination, Row, Table } from "antd";
import React from "react";
import { TABLE_ROWS_COUNT } from "../../constants";

type Props = {
  rowKey?: string;
  loading: boolean;
  dataSource: any[];
  columns: any[];
  maxWidth?: string;
  tableWidth?: any;
  /** When set, table body scrolls vertically and header stays fixed (e.g. `calc(100vh - 360px)` or `480`) */
  scrollY?: string | number;
  defaultPage: number;
  currentPage: number;
  totalRows: number;
  rowSelection?: any;
  onChange?: any;
  /** Forwarded to antd Table - e.g. to make rows clickable */
  onRow?: (record: any, index?: number) => React.HTMLAttributes<HTMLElement>;
  onPageChange: (e: any) => void;
  onPageSizeChange?: (page: number, pageSize: number) => void;
  pagination?: boolean;
  pageSize?: number;
  pageSizeOptions?: string[];
};

const DataTableComponent: React.FC<Props> = ({
  rowKey,
  pagination,
  loading,
  dataSource,
  columns,
  maxWidth = "100%",
  tableWidth = null,
  scrollY,
  defaultPage,
  totalRows,
  onPageChange,
  currentPage,
  rowSelection,
  onChange,
  onRow,
  onPageSizeChange,
  pageSize = TABLE_ROWS_COUNT,
  pageSizeOptions = ["10", "15", "25", "50", "100"],
}: Props) => {
  const scroll: { x?: string | number | true; y?: string | number } = {};
  if (tableWidth) scroll.x = tableWidth;
  if (scrollY != null && scrollY !== "") scroll.y = scrollY;
  const activePage = Number(currentPage) || 1;

  return (
    <>
      <div className="mx-6">
      <div style={{ overflowX: 'auto', maxWidth }}>
        <Table
          className="app-table"
          // tableLayout="auto"
          pagination={false}
          loading={loading}
          scroll={Object.keys(scroll).length ? scroll : undefined}
          rowKey={rowKey}
          dataSource={dataSource}
          columns={columns}
          rowSelection={rowSelection}
          onChange={onChange}
          onRow={onRow}
          size="small"
        />
        {pagination && (
          <Row justify="end" align="middle" className="app-table-pagination">
            <Col className="bg-primary-white-bluish pt-3 pb-3 pr-6">
              <Pagination
                showTotal={(total: any, range: any) =>
                  total > 0 ? `${range[0]}-${range[1]} of ${total} Total` : ""
                }
                responsive={true}
                showSizeChanger={!!onPageSizeChange}
                pageSizeOptions={pageSizeOptions}
                defaultCurrent={defaultPage ? defaultPage : currentPage}
                current={activePage}
                total={totalRows}
                pageSize={pageSize}
                onChange={(page, nextPageSize) => {
                  if (nextPageSize !== pageSize && onPageSizeChange) {
                    onPageSizeChange(page, nextPageSize);
                    return;
                  }
                  onPageChange(page);
                }}
                itemRender={(page, type, originalElement) =>
                  type === "page" ? (
                    <span
                      className={
                        Number(page) === activePage
                          ? "app-pagination-page-number-active"
                          : "app-pagination-page-number"
                      }
                    >
                      {page}
                    </span>
                  ) : (
                    originalElement
                  )
                }
              />
            </Col>
          </Row>
        )}
      </div></div>
    </>
  );
};

export default DataTableComponent;
